import { APP } from "../apiConstant";
import BaseApi from "../baseApi";

class AppApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getList(body) {
    return this.post(`${APP}/list`, body);
  }

  store(body) {
    return this.post(`${APP}/store`, body);
  }

  delete(body) {
    return this.post(`${APP}/delete`, body);
  }
}
export default AppApi;
